<template>
  <v-card class="empty-state-card" flat outlined>
    <v-card-text class="text-center py-12">
      <!-- Loading State -->
      <template v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <div class="text-h6 font-weight-bold grey--text text--darken-2 mt-4">
          {{ title || $t("loading") }}...
        </div>
      </template>

      <!-- Empty State -->
      <template v-else>
        <v-avatar color="grey lighten-3" size="80" class="mb-4">
          <v-icon size="48" color="grey">{{ icon }}</v-icon>
        </v-avatar>
        <div class="text-h6 font-weight-bold grey--text text--darken-2 mb-2">
          {{ title }}
        </div>
        <div v-if="subtitle" class="text-body-2 grey--text text--darken-1 mb-1">
          {{ subtitle }}
        </div>
        <div v-if="$slots.default || $slots.actions" class="empty-state__actions mt-6">
          <slot name="actions">
            <slot />
          </slot>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      default: "mdi-inbox",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.empty-state-card {
  border-radius: 12px;
  border: 2px dashed #e0e0e0 !important;
  background-color: #fafafa;
}

.empty-state__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
